import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-upload-file",
  templateUrl: "./upload-file.component.html",
  styleUrls: ["./upload-file.component.scss"],
})
export class UploadFileComponent implements OnInit {
  @Input() uploadDataContent: any = [];
  @Input() styleClassName: string = "";
  @Input() isMultiple: boolean = false;
  @Output() actionBrowseButtonCall = new EventEmitter<any>();
  @Output() actionFileDropCall = new EventEmitter<any>();
  @Output() actionCancelCall = new EventEmitter<any>();
  @Input() processingValidation: any;
  @Input() disableFileClose: boolean = false;

  saleFileName: string = "";
  saleFileSize: string = "";

  constructor() {}

  ngOnInit(): void {}

  actionFileBrowse(file: any) {
    if (this.uploadDataContent?.inputType === "button") {
      const file = {
        buttonKey: this.uploadDataContent.title,
        hasUploadEnabled: this.uploadDataContent.isUploadEnabled,
      };
      this.actionBrowseButtonCall.emit(file);
      return;
    }

    this.actionBrowseButtonCall.emit(file);
  }

  onFileDragOver(event: DragEvent) {
    event.preventDefault(); // Enable drop
    event.dataTransfer!.effectAllowed = "copy"; // Allow files to be copied
  }

  onFileDrop(event: DragEvent, callFlag: string = "") {
    event.preventDefault();
    event.dataTransfer!.dropEffect = "copy"; // Indicate copy action
    const files = event.dataTransfer?.files;
    if (files) {
      this.actionFileDropCall.emit({
        file: event,
        type: callFlag,
        fileList: files,
      });
    }
  }

  actionFileClear(type: string) {
    this.actionCancelCall.emit(type);
  }
}
